import T from '../../services/language';
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  &.dots {
    align-items: center;
  }
`;
const ItemView = styled.div`
  flex: 1;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    height: 4px;
    width: 100%;
    right: calc(50% + 12px);
    background-color: #DDDDDD;
    top: 10px;
    z-index: 1;
  }

  &:after {
    content: "";
    position: absolute;
    height: 4px;
  }

  &:first-child:before {
    display: none;
  }

  &.active:before {
    // background-color: #1D896D;
  }

  &.active {
    & div {
      color: ${props => props.theme.main || "#1D896D"};
    }

    & > div > div:first-child {
      background-color: ${props => props.theme.main || "#1D896D"};
      color: white;
    }
  }
`
const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

`;
const ItemIndex = styled.div`
  width: 24px;
  height: 24px;
  background: #DDDDDD;
  border-radius: 50px;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #828282;
  position: relative;
  z-index: 2;
`;
const ItemTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #828282;
  margin-top: 4px;
`;

const ItemViewDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.6);
  margin-left: 8px;

  &.active {
    background: #FFF;
    width: 12px;
    height: 12px;
  }
`;

export default function Step(props: { current: number, ignores?: Array<string>, dotStyle?: boolean }) {
    const items = [
        {
            title: T("Location"),
        },
        {
            title: T("Booking"),
        },
        {
            title: T("Questionnaire"),
        },
        {
            title: T("Confirm"),
        },
    ].filter(x => !(props.ignores || []).includes(x.title));

    return (
        <Container className={props.dotStyle ? 'dots' : 'steps'}>
            {items.map((item, index) => {
                const active = ((props.current || 1) === index + 1);
                return props.dotStyle ? (
                    <ItemViewDot key={index.toString()} className={active ? 'active' : ''}></ItemViewDot>
                ) : (
                    <ItemView key={index.toString()} className={active ? 'active' : ''}
                              style={{justifyItems: index === 1 ? "center" : "flex-start"}}>
                        <Item>
                            <ItemIndex>{index + 1}</ItemIndex>
                            <ItemTitle>{item.title}</ItemTitle>
                        </Item>
                    </ItemView>
                )
            })}
        </Container>
    )
}